import React from 'react';
import { useAuth, useTenant } from '../App';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Badge } from './ui/badge';
import { Building2, Crown } from 'lucide-react';

/**
 * Componente de filtro de tenant para usuários Master
 * Deve ser colocado ao lado de outros filtros nas páginas
 */
const TenantFilter = ({ className = '' }) => {
  const { user } = useAuth();
  const { selectedTenant, setSelectedTenant, tenants } = useTenant();

  // Só mostra para usuário Master
  if (user?.role !== 'mestre') {
    return null;
  }

  if (tenants.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Building2 className="w-4 h-4 text-slate-400" />
      <Select value={selectedTenant || 'all'} onValueChange={setSelectedTenant}>
        <SelectTrigger className="w-[220px] h-9" data-testid="tenant-filter">
          <SelectValue placeholder="Todas Organizações" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">
            <div className="flex items-center gap-2">
              <Crown className="w-3 h-3 text-purple-500" />
              Todas as Organizações
            </div>
          </SelectItem>
          {tenants.map((t) => (
            <SelectItem key={t.id} value={t.cnpj}>
              {t.trading_name || t.company_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectedTenant && selectedTenant !== 'all' && (
        <Badge className="bg-purple-100 text-purple-700 text-xs">
          Filtrado
        </Badge>
      )}
    </div>
  );
};

export default TenantFilter;
